// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { AssetTypeSchema } from '../inputTypeSchemas/AssetTypeSchema'

/////////////////////////////////////////
// ASSET REFERENCE SCHEMA
/////////////////////////////////////////

export const AssetReferenceSchema = z.object({
  type: AssetTypeSchema,
  id: z.string(),
})

export type AssetReference = z.infer<typeof AssetReferenceSchema>

export default AssetReferenceSchema;
